module.exports = function getResource(label) {
    const resources = {
        freeReturns: 'Free Returns',
        exclusions: 'see details/exclusions.*'
    };

    return resources[label];
};
